export default __webpack_public_path__ + "static/icon-10-6-7efa09bb842d7b0b025861be8e03ccbc.png";